import type { LinkHubCreatorState } from '../types';

export const INIT_STATE: LinkHubCreatorState = {
  originalWebUrlLinkData: undefined,
  originalWebUrlLinkDataStatus: 0,
  allLinkCollections: undefined,
};
